function noop() {}
import { writable, get } from "svelte/store";
import { navigate } from "svelte-routing";

function modelStore(value) {
	var model = writable(window.theModel);

	async function persistJson(url) {
		try {
			let headers = {
				"Content-type": "application/json; charset=utf-8"
			};
			let data = get(model);
			await makeHttpRequest(url, "POST", headers, JSON.stringify(data));
			return true;
		} catch (err) {
			console.log("Unexpected result:", err);
			navigate("Error");
			return false;
		}
	}

	return { ...model, persistJson };
}

export const makeHttpRequest = function (url, method, headers, data) {
	// Create the XHR request
	let request = new XMLHttpRequest();

	// Return it as a Promise
	return new Promise(function (resolve, reject) {
		// Setup our listener to process compeleted requests
		request.onreadystatechange = function () {
			// Only run if the request is complete
			if (request.readyState !== 4) return;

			// Process the response
			if (request.status >= 200 && request.status < 300) {
				// If successful
				resolve(request);
			} else {
				// If failed
				reject({
					status: request.status,
					statusText: request.statusText
				});
			}
		};

		// Setup our HTTP request
		request.open(method || "GET", url, true);

		// Add headers
		for (var header in headers) {
			if (headers.hasOwnProperty(header)) {
				request.setRequestHeader(header, headers[header]);
			}
		}

		// Send the request
		request.send(data);
	});
};

export const model = modelStore(window.theModel);
export const pageNumber = writable(1);
